import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import shallowCompare from 'react-addons-shallow-compare';
import { displayCreationModal } from 'saas/sites/modals';
import { displayCreationModal as displayContactCreationModal } from 'saas/contacts/modals';
import Dropdown from 'modules/common/components/Dropdown';
import Modal from 'common/components/Modal';
import cx from 'classnames';

class SiteContactSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this._onAddSite = this._onAddSite.bind(this);
    this._onAddContact = this._onAddContact.bind(this);
  }

  _onAddSite(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onSiteAdded;

    // Displaying site modal
    displayCreationModal(this.props.customer, onSaved);
  }

  _onAddContact(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onContactAdded;

    // Displaying contact modal
    displayContactCreationModal(this.props.customer, onSaved);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const {
      sites,
      contacts,
      selectedSite,
      onSiteSelected,
      selectedContact,
      onContactSelected,
      errors,
    } = this.props;

    const isSiteSelected = s => selectedSite === s.id.toString();

    const filteredSites = sites.filter(
      s => s.deleted !== true || isSiteSelected(s)
    );

    const isContactSelected = c => selectedContact === c.id.toString();

    const filteredContacts = contacts.filter(
      c => c.deleted !== true || isContactSelected(c)
    );

    const hasError = (global = false) => {
      if (errors) {
        return errors.has('site.empty');
      }
      return false;
    };

    const onModalConfirm = () => {
      this.setState({
        warningModalOpened: false,
        warningModalSite: undefined,
      });
    };

    const onModalClose = id => {
      this.setState({
        warningModalOpened: false,
        warningModalSite: undefined,
      });
    };

    const segmentClasses = cx('ui segment form', {
      error: hasError(),
    });

    const { warningModalOpened } = this.state;

    const renderSiteDefault = placeholder => (
      <div className="default text">Site concerné par la demande</div>
    );

    const renderContactDefault = placeholder => (
      <div className="default text">Contact site concerné par la demande</div>
    );

    const renderItem = item => (
      <div key={item.id} data-value={item.id} className="item">
        {item.name}
      </div>
    );

    const renderContactItem = item => (
      <div key={item.id} data-value={item.id} className="item">
        {item.last_name} {item.first_name}
      </div>
    );

    return (
      <div className={segmentClasses}>
        <h3 className="ui header">
          Choix du site et du contact
          <button
            className="ui right floated labeled icon button"
            onClick={this._onAddContact}
          >
            <i className="icon add" />
            Ajouter un contact
          </button>
          <button
            className="ui right floated labeled icon button"
            onClick={this._onAddSite}
          >
            <i className="icon add" />
            Ajouter un site
          </button>
        </h3>
        <div>
          Si votre demande concerne plusieurs sites, créez{' '}
          <a style={{ color: 'teal' }} href={`/pco-manager/cases-creation/new`}>
            une demande standard
          </a>
          .
        </div>
        {hasError(true) && (
          <div className="ui error message">
            <p>Vous devez sélectionner au moins un site.</p>
          </div>
        )}
        <br />

        <div className="ui grid">
          <div className="eight wide column">
            <div className="required field">
              <label>Site</label>
              <Dropdown
                name="site"
                value={selectedSite}
                canDelete={true}
                items={filteredSites}
                renderDefault={renderSiteDefault}
                renderItem={renderItem}
                onChange={onSiteSelected}
                fluid
              />
            </div>
          </div>
          <div className="eight wide column">
            <div className="field">
              <label>Contact site</label>
              <Dropdown
                name="contact"
                value={selectedContact}
                canDelete={true}
                items={filteredContacts}
                renderDefault={renderContactDefault}
                renderItem={renderContactItem}
                onChange={onContactSelected}
                fluid
              />
            </div>
          </div>
        </div>

        <Modal
          isOpened={!!warningModalOpened}
          closable
          onConfirm={onModalConfirm}
          onClose={onModalClose}
        >
          <div className="header">Suppression</div>
          <div className="content">
            <div>Êtes-vous sûr(e) de vouloir supprimer cet élément ?</div>
          </div>
          <div className="actions">
            <div className="actions">
              <button className="ui button" onClick={onModalClose}>
                : qui est Annuler
              </button>
              <button className="ui red button" onClick={onModalConfirm}>
                Confirmer
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

SiteContactSelector.propTypes = {
  customer: PropTypes.string.isRequired,
  sites: PropTypes.array.isRequired,
  selectedSite: PropTypes.string.isRequired,
  selectedContact: PropTypes.string.isRequired,
  onSiteAdded: PropTypes.func.isRequired,
  onSiteSelected: PropTypes.func.isRequired,
  onContactAdded: PropTypes.func.isRequired,
  onContactSelected: PropTypes.func.isRequired,
  errors: ImmutablePropTypes.map,
};

export default SiteContactSelector;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/SiteContactSelector.js